module.exports = __webpack_public_path__ + "img/dog-61a4c8e.gif";